import { Breadcrumb } from "@components/anti"
import { useScrollAnim } from "@components/hooks/hooks"
import { useRouter } from "next/router"
import ProjectGalleryCard from "./project-gallery-card"

export default function ProjectGalleryByCategories({ list, title, slug }) {
  const { locale } = useRouter()
  const [trigger, anim] = useScrollAnim()
  const [trigger2, anim2] = useScrollAnim()

  return (
    <>
      <section className="sc-project-gallery-header" ref={trigger}>
        <div className="container py-3">
          <Breadcrumb
            linkData={[
              { text: "Home", url: "/" },
              {
                text:
                  locale === "en"
                    ? "Project Gallery & Events"
                    : "Proyek & Event",
                url: "/project-gallery",
              },
              {
                text: title,
              },
            ]}
            className={anim(1)}
          />
          <h1 className={anim(2)}>{title}</h1>
        </div>
      </section>
      <div ref={trigger2} />
      <section className="sc-project-gallery-categories">
        <div className="container py-3">
          <div className="row">
            {list?.map((item, index) => (
              <div className="col-12 col-md-4 mb-4" key={index}>
                <ProjectGalleryCard
                  image={item.image}
                  title={item.title}
                  link={`/project-gallery/${slug}/${item?.slug}-${item?.id}`}
                  className={anim2(index + 1)}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
